module.exports = __webpack_public_path__ + "static/media/background-alpha-1x.321297af.jpg";